module.exports = __webpack_public_path__ + "86b215b9863312f744870edf65c800ad.jpg";